import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import {Box, Container, Grid, Typography} from '@material-ui/core'
import profileImage from '../../resources/profile.jpg'
import { LanguageSharp } from '@material-ui/icons';

const language = ['Javascript', 'Ruby', 'CSS', 'HTML5'];
const frameworks = ['React', 'Express', 'Ruby on Rails'];
const tools = ['redux', 'MongoDb', 'Postgresql', 'Nodejs', 'Material-ui'];
const design = ['figma', 'Photoshop', 'Illustator'];

const useStyles = makeStyles(theme => ({
    container: {
        // border: '1px solid blue',
    },
    imageContainer: {
        // border: '1px solid blue',
        [theme.breakpoints.down('xs')]: {
            marginLeft: 0,
        },
        height: 400,
        marginLeft: 20,
    },
    textContainer: {
        // border: '1px solid blue',
        height: 400,
    },
    text: {
        // border: '1px solid lightblue',
        width: 500,
    },
    squareBox: {
        [theme.breakpoints.down('md')]: {
            top: 0,
            left: 0,
            height: 0,
            width: 0,
        },
        [theme.breakpoints.down('sm')]: {
            top: 330,
            left: 70,
            height: 300,
            width: 300,
        },
        [theme.breakpoints.down('xs')]: {
            top: 300,
            left: 0,
            height: 380,
            width: '100%',
        },
        // [theme.breakpoints.between("md", "lg")] : {
        //     top: 340,
        //     left: 80,
        //     height: 300,
        //     width: 300,
        // },
        [theme.breakpoints.between("1280", "1400")]: {
            top: 500,
            left: 80,
            height: 300,
            width: 300,
        },
        zIndex: '1',
        position: 'absolute',
        top: 340,
        left: 200,
        height: 300,
        width: 300,
        backgroundColor: theme.palette.primary.light,
    },
    rightAngleGraphic: {
        [theme.breakpoints.down('md')]: {
            top: -70,
            left: -20,
            height: 80,
            width: 80,
            borderRight: 0,
            borderBottom: 0,
            borderLeft: `5px solid ${theme.palette.primary.dark}`,
            borderBottom: `5px solid ${theme.palette.primary.dark}`,
        },
        [theme.breakpoints.down('sm')]: {
            top: 130,
            left: -320,
            height: 80,
            width: 80,
            borderRight: 0,
            borderBottom: 0,
            borderLeft: `5px solid ${theme.palette.primary.dark}`,
            borderBottom: `5px solid ${theme.palette.primary.dark}`,
        },
        [theme.breakpoints.down('xs')]: {
            top: -20,
            left: 0,
            height: 0,
            width: '100%',
            borderRight: '0',
            borderBottom: `5px solid ${theme.palette.primary.dark}`,
        },
        [theme.breakpoints.between("1280", "1400")]: {
            top: 130,
            left: -320,
            height: 80,
            width: 80,
            borderRight: 0,
            borderBottom: 0,
            borderLeft: `5px solid ${theme.palette.primary.dark}`,
            borderBottom: `5px solid ${theme.palette.primary.dark}`,
        },
        zIndex: '1',
        position: 'relative',
        top: 130,
        left: -60,
        height: 80,
        width: 80,
        borderRight: `5px solid ${theme.palette.primary.dark}`,
        borderBottom: `5px solid ${theme.palette.primary.dark}`,
    },
    skillsContainer: {
        // border: '1px solid blue',
        [theme.breakpoints.down('xs')]: {
            marginBottom: '180px',
        },
        height: 250,
        margin: '50px 0',
    },
    skillsHeading: {
        // border: '1px solid lightblue',
        height: 50
    },
    skillList: {
        [theme.breakpoints.down('sm')]: {
            width: 600,
        },
        [theme.breakpoints.down('xs')]: {
            width: 300,
        },
        // border: '1px solid lightblue',
        height: 200,
        width: 1000,
    },
    textColor: {
        color: theme.palette.primary.main
    },
}))

const AboutPage = () => {

    const classes = useStyles();

    return (
        <Container maxWidth="lg">
            <Grid container className={classes.container} >
                {/* image */}
                <Grid item xs={12} md={4}>
                    <Grid container direction="row" justifyContent="flex-start" alignItems="center" className={classes.imageContainer}>
                        <Grid item className={classes.squareBox}></Grid>
                        <img src={profileImage} alt="profile" height="300" width="300" style={{zIndex: '99',}} />
                        <Grid item className={classes.rightAngleGraphic}></Grid>
                    </Grid>
                </Grid>

                {/* about me */}
                <Grid item xs={12} md={8}>
                    <Grid container justifyContent="center" alignItems="center" className={classes.textContainer}>
                        <Grid item xs={12} md={7}>
                            <Typography color="textPrimary" variant="h5" gutterBottom>
                                <b>About Me</b>
                            </Typography>
                            <Typography color="textPrimary" variant="subtitle1">
                                I am an <b className={classes.textColor}>enthusiastic</b>, <b className={classes.textColor}>focused</b> and <b className={classes.textColor}>motivated</b> front-end developer seeking an opportunity to change careers to web industries by implementing concepts, 
                                knowledge, and methodologies learnt thereby adding value for the organization. <b className={classes.textColor}>Excellent communication skills</b> - both oral and written.
                                {' '}<b className={classes.textColor}>Flexible</b> and <b className={classes.textColor}>adaptable</b> to demands of changing work environments and technologies. Team player and also <b className={classes.textColor}>independently responsible</b>.
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                {/* skills */}
                <Grid container direction="row-reverse" xs={12} className={classes.skillsContainer}>
                        <Grid item xs={12} className={classes.skillsHeading}>
                           <Typography color="textPrimary" variant="h5">
                                <b>Skills</b>
                            </Typography> 
                        </Grid>

                        <Grid container className={classes.skillList}>
                            {/* languages */}
                            <Grid item xs={6} sm={3} >
                                <Typography color="textPrimary" variant="h6">
                                    <b>Languages</b>
                                </Typography>
                                {language.map(item => (
                                    <div key={item}>
                                        <Typography color="textPrimary" variant="subtitle1">
                                            {item}
                                        </Typography>
                                    </div>
                                ))}
                            </Grid>
                            {/* frameworks */}
                            <Grid item xs={6}  sm={3} >
                                <Typography color="textPrimary" variant="h6">
                                    <b>Frameworks</b>
                                </Typography>
                                {frameworks.map(item => (
                                    <div key={item}>
                                        <Typography color="textPrimary" variant="subtitle1">
                                            {item}
                                        </Typography>
                                    </div>
                                ))}
                            </Grid>
                            {/* tools */}
                            <Grid item xs={6}  sm={3} >
                                <Typography color="textPrimary" variant="h6">
                                    <b>Tools</b>
                                </Typography>
                                {tools.map(item => (
                                    <div key={item}>
                                        <Typography color="textPrimary" variant="subtitle1">
                                            {item}
                                        </Typography>
                                    </div>
                                ))}
                            </Grid>
                            {/* design */}
                            <Grid item xs={6}  sm={3} >
                                <Typography color="textPrimary" variant="h6">
                                    <b>Design</b>
                                </Typography>
                                {design.map(item => (
                                    <div key={item}>
                                        <Typography color="textPrimary" variant="subtitle1">
                                            {item}
                                        </Typography>
                                    </div>
                                ))}
                            </Grid>
                        </Grid>
                </Grid>

            </Grid>
        </Container>
    )
}

export default AboutPage
